/** Längste Kante nach dem Verkleinern: genug für lesbare Rechnungen, klein genug fürs Handynetz. */
export const MAX_KANTE = 2400;
const JPEG_QUALITAET = 0.85;
const KLEIN_GENUG_BYTES = 1_500_000;

export function verkleinerteAbmessung(breite: number, hoehe: number, maxKante = MAX_KANTE): { breite: number; hoehe: number } {
  const faktor = Math.min(1, maxKante / Math.max(breite, hoehe));
  return { breite: Math.max(1, Math.round(breite * faktor)), hoehe: Math.max(1, Math.round(hoehe * faktor)) };
}

export function jpgName(name: string): string {
  const basis = name.replace(/\.[^./\\]+$/, "");
  return `${basis || "foto"}.jpg`;
}

/**
 * Verkleinert Fotos vor dem Upload (JPEG, lange Kante ≤ 2400 px). PDFs und alles, was schiefgeht, bleiben
 * unverändert: Ein Upload soll nie an der Vorverarbeitung scheitern.
 */
export async function bildVerkleinern(datei: File): Promise<File> {
  if (!datei.type.startsWith("image/") || typeof createImageBitmap !== "function") return datei;
  try {
    const bitmap = await createImageBitmap(datei);
    const { breite, hoehe } = verkleinerteAbmessung(bitmap.width, bitmap.height);
    const verkleinert = breite < bitmap.width || hoehe < bitmap.height;
    if (!verkleinert && datei.type === "image/jpeg" && datei.size <= KLEIN_GENUG_BYTES) {
      bitmap.close();
      return datei;
    }
    const leinwand = document.createElement("canvas");
    leinwand.width = breite;
    leinwand.height = hoehe;
    const kontext = leinwand.getContext("2d");
    if (!kontext) {
      bitmap.close();
      return datei;
    }
    kontext.fillStyle = "#ffffff"; // transparente PNGs werden sonst schwarz
    kontext.fillRect(0, 0, breite, hoehe);
    kontext.drawImage(bitmap, 0, 0, breite, hoehe);
    bitmap.close();
    const blob = await new Promise<Blob | null>((resolve) => leinwand.toBlob(resolve, "image/jpeg", JPEG_QUALITAET));
    if (!blob || (!verkleinert && blob.size >= datei.size)) return datei;
    return new File([blob], jpgName(datei.name), { type: "image/jpeg", lastModified: datei.lastModified });
  } catch {
    return datei;
  }
}
